"use client";

import { Event, Group, Resource, Workspace } from "@/db/schema";
import { cn } from "@/lib/utils";
import { useRouter, useSearchParams } from "next/navigation";
import { useCallback } from "react";
import { ResourceColumn } from "./ResourceColumn";

interface Props {
  resources: Resource[];
  workspace: Workspace;
  from: Date;
  to: Date;
  events: Event[];
  group: Group;
}

export const ResourceGrid: React.FC<Props> = ({
  resources,
  workspace,
  to,
  from,
  events,
  group,
}) => {
  const searchParams = useSearchParams();
  const selectedResource = searchParams.get("selectedResource");
  const router = useRouter();

  const setSelectedResource = useCallback(
    (id: string | null) => {
      const currentParams = new URLSearchParams(searchParams.toString());
      if (id) {
        currentParams.set("selectedResource", id);
      } else {
        currentParams.delete("selectedResource");
      }
      const newSearchParams = currentParams.toString();
      const query = newSearchParams ? `?${newSearchParams}` : "";
      router.push(query);
    },
    [router, searchParams],
  );

  return (
    <div className="">
      <div className="grid grid-cols-3 gap-2 px-2 mt-2">
        {resources.map((resource) => (
          <div
            key={resource.id}
            className={cn(
              `cursor-pointer hover:shadow-lg transition-shadow p-2 rounded border
                ${
                  selectedResource && selectedResource === resource.id
                    ? " border-neutral-300 shadow-lg"
                    : "opacity-50"
                }
              `,
            )}
            onClick={() => setSelectedResource(resource.id)}
          >
            <p className="text-sm">{resource.name}</p>
            <p className="text-xs text-gray-500">Capacity: {resource.capacity}</p>
          </div>
        ))}
      </div>
      {selectedResource && (
        <div className="mt-2">
          <ResourceColumn
            group={group}
            workspace={workspace}
            resource={resources.find((r) => r.id === selectedResource)!}
            resourceIndex={0}
            events={events.filter((e) => e.resourceId === selectedResource)}
            from={from}
            to={to}
            standalone={true}
          />
        </div>
      )}
    </div>
  );
};
